export function formatDecimal(value?: number | null) {
	if (value === undefined || value === null) {
		return "-";
	}
	return "" + value.toFixed(2);
}
